import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { downloadBlob } from '@shared/shared.utils'
import { of } from 'rxjs'
import { catchError, map, switchMap, tap } from 'rxjs/operators'
import {
  ExportAuditLogsFailure,
  ExportAuditLogsRequest,
  ExportAuditLogsSuccess,
  FetchAuditLogInfoFailure,
  FetchAuditLogInfoRequest,
  FetchAuditLogInfoSuccess,
  FetchAuditLogsFailure,
  FetchAuditLogsRequest,
  FetchAuditLogsSuccess,
} from './audit-logs.actions'
import { AuditLogsService } from './audit-logs.service'
import * as AuditLogsTypes from './audit-logs.types'

@Injectable()
export class AuditLogsEffects {
  constructor(
    private actions: Actions,
    private auditLogsService: AuditLogsService,
    private router: Router,
  ) {}

  FetchAuditLogs$ = createEffect(() =>
    this.actions.pipe(
      ofType(AuditLogsTypes.FETCH_AUDIT_LOGS_REQUEST),
      switchMap((action: FetchAuditLogsRequest) => {
        return this.auditLogsService.fetchAuditLogs(action.payload).pipe(
          map((result) => {
            return new FetchAuditLogsSuccess(
              result.data.results,
              result.data.filteredCount,
              result.data.totalCount,
            )
          }),
          catchError((err, caught) => {
            return of(new FetchAuditLogsFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  ExportAuditLogs$ = createEffect(() =>
    this.actions.pipe(
      ofType(AuditLogsTypes.EXPORT_AUDIT_LOGS_REQUEST),
      switchMap((action: ExportAuditLogsRequest) => {
        return this.auditLogsService.exportAuditLogs(action.payload).pipe(
          map((result) => {
            return new ExportAuditLogsSuccess(result)
          }),
          catchError((err, caught) => {
            return of(new ExportAuditLogsFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  SaveReport$ = createEffect(
    () =>
      this.actions.pipe(
        ofType<ExportAuditLogsSuccess>(
          AuditLogsTypes.EXPORT_AUDIT_LOGS_SUCCESS,
        ),
        tap((action) => downloadBlob(action.blob)),
      ),
    { dispatch: false },
  )

  FetchAuditLogInfo$ = createEffect(() =>
    this.actions.pipe(
      ofType(AuditLogsTypes.FETCH_AUDIT_LOG_INFO_REQUEST),
      switchMap((action: FetchAuditLogInfoRequest) => {
        return this.auditLogsService.fetchAuditLogInfo(action.id).pipe(
          map((result) => {
            return new FetchAuditLogInfoSuccess(result.data.details)
          }),
          catchError((err, caught) => {
            return of(new FetchAuditLogInfoFailure({ error: err }))
          }),
        )
      }),
    ),
  )
}
